"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/RecordConsentModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _consent = require('shared/services/consent');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _ConsentHowFields = require('web/components/ConsentHowFields'); var _ConsentHowFields2 = _interopRequireDefault(_ConsentHowFields);

const NOTE_MAX_LENGTH = 500















// Consent a contact gave outside a text (a signed form, a call, a visit).
// The server texts the confirmation, then anything waiting for consent.
const RecordConsentModal = ({ isOpen, patientName, onClose, onConfirm }) => {
  const [how, setHow] = _react.useState(null)
  const [date, setDate] = _react.useState.call(void 0, '')
  const [note, setNote] = _react.useState.call(void 0, '')
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    setHow(null)
    setDate(_consent.todayConsentDate.call(void 0, ))
    setNote('')
  }, [isOpen])

  const onNoteChange = _react.useCallback.call(void 0, (e) => setNote(e.target.value), [])

  const save = _react.useCallback.call(void 0, () => {
    if (!how || !date) return
    setIsSaving(true)
    onConfirm({ how, date, note: note.trim() })
      .catch(() => undefined)
      .finally(() => setIsSaving(false))
  }, [how, date, note, onConfirm])

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: _consent.RECORD_CONSENT_LABEL, size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Record that "
          ,  patientName || 'this contact' , " agreed to get texts. BloomText texts them the confirmation, then any messages waiting for consent."

      )
      , _react2.default.createElement(_ConsentHowFields2.default, {
        howLabel: "How did they agree?"   ,
        how: how,
        onHowChange: setHow,
        date: date,
        onDateChange: setDate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Note", isOptional: true, className: "consent-how-fields--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
        , _react2.default.createElement(_Form.SimpleTextArea, {
          'aria-label': "Note",
          value: note,
          onChange: onNoteChange,
          maxLength: NOTE_MAX_LENGTH,
          placeholder: "Signed the placement packet"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: _consent.RECORD_CONSENT_LABEL,
        secondaryBtnLabel: "Cancel",
        isPrimaryLoading: isSaving,
        isPrimaryEnabled: !!how && !!date && !isSaving,
        onPrimaryBtnClick: save,
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
      )
    )
  )
}

exports. default = RecordConsentModal
